angular.module('account').controller('LoginConsentCtrl',
    [
        '$scope', 
        'SessionService', 
        '$q', 
        'ConsentService', 
        'LocalStorageRepository', 
        'TransitionManager', 
        'ConsentRepository', 
        'LogOffService', 
        'aprgettext',
        'BrowserService',
        function (
            $scope, 
            SessionService, 
            $q, 
            ConsentService, 
            LocalStorageRepository, 
            TransitionManager, 
            ConsentRepository, 
            LogOffService, 
            gettext,
            BrowserService
        ) {
            'use strict';

            $scope.loading = true;
            $scope.submitted = false;

            $scope.loginConsent = {
                PracticeConsentText: '',
                PDFPath: '',
                AgreeToConsentChecked: false,
                PracticeConsentAccepted: false,
                AprimaConsent: gettext('Clicking on Agree denotes that you are authorized to view the above patient records and agree to be bound by the terms and conditions of the Patient Portal.'),
                ConsentWarningMessage: gettext('Please indicate that you agree with this consent form and select the Agree checkbox to proceed.'),
                AgreeCheckboxText: gettext('I have read the consent form and the above information and I accept the conditions')
            };

            $scope.model =
            {
                DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                DocumentId: 'privacypolicy',
            };

            function getPrivacyPolicyUrl() {
                return ConsentService
                    .getPrivacyPolicyUrl()
                    .then(function (privacyPolicyUrl) {
                        $scope.loginConsent.PDFPath = privacyPolicyUrl;
                    });
            }

            function getPracticeConsent() {
                return ConsentService
                    .getPracticeConsent()
                    .then(function (data) {
                        $scope.loginConsent.PracticeConsentAccepted = data.IsAccepted;
                        $scope.loginConsent.PracticeConsentText = data.ConsentForm;
                    });
            }

            function getPrivacyPolicy() {
                return ConsentRepository.downloadAgreementPrivacyPolicy();
            }

            function downloadPrivacyPolicy(){
                return ConsentRepository.downloadAgreementPrivacyPolicy()
                    .then(function (data) {
                        return {Data: data.Data, FileName: 'PrivacyPolicy', Extension: 'pdf'};
                    });
            }

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();

                var practiceConsentPromise = getPracticeConsent();
                var getPrivacyPolicyPromise = getPrivacyPolicyUrl();

                $q.all([practiceConsentPromise, getPrivacyPolicyPromise])
                    .then(function () {
                        if ($scope.loginConsent.PracticeConsentAccepted === true) {
                            SessionService.setDisplayDashboardToolbar(true);
                            SessionService.setShowHeaderNavigationMenu(true);
                            TransitionManager.transition({appRoute: 'dashboard'});
                        }
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            loadPage();

            function disagreeToConsent() {
                LogOffService.logoff().then(function () {
                    TransitionManager.transition({appRoute: 'login'});
                });
            }

            function submitForm() {
                if ($scope.loginConsentForm.$invalid) {
                    return;
                }

                $scope.submitted = true;
                ConsentRepository
                    .postUserAgreedToPracticeConsent(LocalStorageRepository.getUserID())
                    .then(function () {
                        $scope.removeHttpError();
                        SessionService.setDisplayDashboardToolbar(true);
                        SessionService.setShowHeaderNavigationMenu(true);
                        TransitionManager.transition({appRoute: 'dashboard'});
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    });
                $scope.submitted = false;
            }

            $scope.downloadPrivacyPolicy = downloadPrivacyPolicy;
            $scope.getPrivacyPolicy = getPrivacyPolicy;
            $scope.submitForm = submitForm;
            $scope.disagreeToConsent = disagreeToConsent;

        }
    ]
);